import React from 'react';
import PageHeader from '../components/PageHeader';
import Reveal from '../components/Reveal';

const CDN = 'https://media.base44.com/images/public/69fb50eacfcd0fff531785bf';

const About = () => {
  return (
    <div>
      <PageHeader
        eyebrow="Our Story"
        title="The Bubble Of Andobrée"
        intro="Andobrèe was founded in 2025 in Hungary by young fashion designer Anna Dobrovits. From the very beginning, the vision behind the brand was clear: to create fashion without limitations, where individuality is celebrated and everyone is welcome."
      />

      {/* Image block */}
      <section className="px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <Reveal variant="image" duration={1400}>
            <div className="aspect-[3/2] overflow-hidden bg-neutral-100">
              <img
                src={`https://customer-assets.emergentagent.com/job_optimize-web-3/artifacts/xgakxxuo_about.jpeg`}
                alt="Andobrée atelier"
                className="w-full h-full object-cover"
                style={{ objectPosition: 'center 12%' }}
              />
            </div>
          </Reveal>
        </div>
      </section>

      {/* Two column narrative */}
      <section className="py-32 px-6 lg:px-12">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-16">
          <Reveal>
            <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-6">Origins</p>
            <h2 className="font-display text-3xl md:text-4xl font-medium tracking-tight mb-6 leading-tight">
              Founded in Hungary, make art confuse people.
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <div className="space-y-5 text-[15px] leading-relaxed text-neutral-600">
              <p>
                Every Andobrèe creation is deeply connected to Anna s own life experiences, emotions, and observations of the world around her. Fashion became a way to tell stories, transform memories into wearable art, and express ideas that cannot always be put into words. Rather than following trends, Andobrèe focuses on creating something that has never existed before.
              </p>
              <p>
                Since its founding, Andobrèe has participated in numerous fashion shows, continuously sharing its vision with a growing audience and proving that originality always has a place in the fashion world.
              </p>
              <p>
                The main reason Andobrèe was born was simple: to build a brand for everyone. Age, appearance, background, or body type should never determine whether someone feels confident in what they wear. Our mission is to create pieces that make people feel comfortable, seen, and extraordinary in their own way.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Pillars grid */}
      <section className="py-24 px-6 lg:px-12 bg-[#fafaf8]">
        <div className="max-w-[1400px] mx-auto">
          <Reveal variant="fade">
            <p className="text-[11px] tracking-[0.22em] uppercase text-neutral-500 mb-4 text-center">What We Stand For</p>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-display text-4xl md:text-5xl font-medium tracking-tight text-center mb-16">
              Three quiet principles.
            </h2>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-10">
            {PILLARS.map((p, i) => (
              <Reveal key={p.title} delay={i * 140}>
                <div className="bg-white p-10 h-full">
                  <span className="font-display text-3xl text-neutral-300">0{i + 1}</span>
                  <h3 className="font-display text-2xl font-medium mt-4 mb-3">{p.title}</h3>
                  <p className="text-sm text-neutral-600 leading-relaxed">{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

const PILLARS = [
  {
    title: 'Material First',
    body: 'Every piece begins at the mill. We source only from houses we have visited, with fibres traceable to the farm, field or flock.',
  },
  {
    title: 'Made Slowly',
    body: 'Small runs. Hand-finished seams. Pattern pieces cut by people who have been cutting them for twenty years.',
  },
  {
    title: 'Built to Stay',
    body: 'We design for the tenth wear, not the first. Archives are repairable; seasonless silhouettes come back, never out.',
  },
];

export default About;
